import { TableCell, TableRow } from "@material-ui/core";
import React from "react";

const EmptyBody = props => {
  return (
    <React.Fragment>
      <TableRow>
        <TableCell
          colSpan={props.colSpan}
          style={{ textAlign: "center", border: "0px", width: "100%" }}
        >
          {props.placeHolder}
        </TableCell>
      </TableRow>
      {[...Array(props.rowSpan - 1)].map((a,i) => {
        return <TableRow key={i} />;
      })}
    </React.Fragment>
  );
};

export default EmptyBody;



// WEBPACK FOOTER //
// ./src/components/Table/EmptyBody.jsx